export type Faq = {
  q: string;
  a: string;
  group: string;
};

export const faqGroups = ["关于吃瓜路线", "事件整理方法", "信息与版权", "参与与反馈"];

export const faqs: Faq[] = [
  {
    group: "关于吃瓜路线",
    q: "「吃瓜路线」到底是什么？",
    a: "它不是一个催更八卦的吃瓜账号，而是一个事件整理内容平台。我们把散落在社交平台、媒体和公告里的零散信息，用时间线、人物关系、观点光谱和信息溯源的方式重新组织，帮助你在围观复杂公共话题时不云里雾里。",
  },
  {
    group: "关于吃瓜路线",
    q: "为什么你们把栏目叫「瓜田分布」「热点坐标」？",
    a: "这是沿用了大家熟悉的网络比喻：把值得围观的话题比作「瓜」。瓜田分布指栏目的分类地图，热点坐标指当前热度靠前的话题榜单。比喻只是表达方式，内容本身仍坚持来源可查、逻辑清晰的原则。",
  },
  {
    group: "关于吃瓜路线",
    q: "吃瓜路线是否会收录针对个人的负面内容？",
    a: "不会。我们只整理面向公众的事件、行业现象与讨论，不收集针对特定个人的隐私与侮辱性信息，也拒绝为未经证实的指控「定罪」。整理的价值是帮助读者理性判断，而非助长情绪站队。",
  },
  {
    group: "事件整理方法",
    q: "一份「事件地图」是怎么做出来的？",
    a: "通常分四步：先按时间排出关键节点；再标出每个节点的信息来源类型（公告、媒体、网友讨论）；然后汇总各方公开立场并标明冲突点；最后单独列出「已证实」与「未证实」清单。这样读者可以快速判断哪一环存疑。",
  },
  {
    group: "事件整理方法",
    q: "为什么把「未证实」单独列出来？",
    a: "因为多数争议的混乱，来自把推测、情绪和事实混在一起。我们把证据强度分层，只对能指向公开信源的内容标注为「已证实」，其余一律归入「待核实」。这是让整理结论可信的关键。",
  },
  {
    group: "事件整理方法",
    q: "时间线里会不会有遗漏或错误？",
    a: "会。我们依赖公开信息，时效与来源都可能带来偏差。每条时间线都保留信息来源类型，并在页面标注更新日期；若发现偏差，欢迎通过反馈入口指正，我们会修订并标注勘误。",
  },
  {
    group: "信息与版权",
    q: "网站上的观点和评论来源如何署名？",
    a: "各方观点均注明归属（官方公告、媒体、整理型网友等）。网友评论只摘录公开可检索的高赞表达并尽量匿名化昵称。我们尊重原作者，仅在「引用—整理」意义上使用，不做二次虚构。",
  },
  {
    group: "信息与版权",
    q: "为什么示例案例多是化名与行业性描述？",
    a: "为了让整理方法可被普遍验证，同时避免对具体个人与品牌造成先入为主的负面定性。我们更倾向讨论「类型化事件」与「公共规则」，这也是克制而负责任的整理态度。",
  },
  {
    group: "参与与反馈",
    q: "发现时间线有误，如何反馈？",
    a: "你可通过关于页的联系邮箱提交勘误，并附上对应信源链接。核实后我们会在原页面标注「勘误」并更正。我们欢迎监督，这也是信息整理该有的样子。",
  },
  {
    group: "参与与反馈",
    q: "我能否转载或引用站内的整理内容？",
    a: "站内原创整理文案欢迎在注明出处「吃瓜路线」的前提下以合理引用方式转载。长文转载请先通过联系邮箱与我们沟通，注明授权用途即可。",
  },
];